const doc = [({"ko":({"adminConstantHotelPriceUpdateType":({"absolute":"가격 설정", "relative":"원래 가격 조정"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;